import { gql } from '__generated__';

export default gql(`
  query GetScannersForEvent($project_id: ID!, $event_id: ID!) {
    project(id: $project_id) {
      id
      event(id: $event_id) {
        id
        scanner_url
        scanner_password
        scanner_token
        scanners {
          id
          title
          check_in_count
          code_count
          enabled
        }
      }
    }
  }
`);
